import getQueryItem from "./getQueryItem";

const base64DecodeStateParam = (): string =>
  atob(decodeURIComponent(getQueryItem("state", location.hash) || ""));

export default base64DecodeStateParam;
